import { CheckboxV2 } from '@insights-ltd/design-library/components';
import { spacingSizeMap } from '@insights-ltd/design-library/themes';
import { styled } from '@mui/material';
import Grid from '@mui/material/Grid';
import { CheckBoxProps } from '../SearchFilter.types';
import { searchInputWidth } from './SearchInput';

export const OverheadSearchLabelContainer = styled('div')({
  '& > div': {
    minWidth: '0',
  },
  '& > div > p': {
    padding: '1px 0 5px',
    marginBottom: '1rem',
    fontWeight: '300',
  },
});

export const SearchLabelContainer = styled('div')({
  marginRight: '1rem',
  '& > div': {
    minWidth: '0',
  },
  '& > div > p': {
    padding: '1px 0 5px',
    marginTop: '0',
    marginBottom: '0',
    fontWeight: '300',
  },
});

export const FieldLabel = styled('div')({
  display: 'inline-flex',
  flexShrink: '0',
  paddingRight: '1rem',
  paddingTop: '0.5rem',
});

export const CheckBox = (checkbox: CheckBoxProps) => (
  <Grid
    sx={(theme) => ({
      display: 'flex',
      alignItems: 'center',
      '> label > span:nth-of-type(1)': {
        marginRight: theme.spacing(spacingSizeMap.XS),
      },
    })}
    size={{ xs: 8, md: 'auto' }}
  >
    <CheckboxV2
      onChange={() => checkbox.onChange(!checkbox.checked)}
      checked={checkbox.checked}
      label={checkbox.label}
      data-testid="search-filter-checkbox"
    />
  </Grid>
);

export const StyledForm = styled('form')({
  position: 'relative',
  display: 'inline-flex',
  flexShrink: '0',
});

export const MinCharacterWarning = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.blue.dark,
  color: theme.palette.common.white,
  width: `${searchInputWidth}px !important`,
  position: 'absolute',
  fontWeight: theme.typography.fontWeightBold,
  lineHeight: '28px',
  padding: '10px 10px 6px 13px',
  borderBottomRightRadius: '4px',
  borderBottomLeftRadius: '4px',
  [theme.breakpoints.down('sm')]: {
    width: `100%`,
  },
}));
